module.exports = __webpack_public_path__ + "img/GWM_thumbnail.7a15b4b0.png";